module.exports = __webpack_public_path__ + "img/how-to-combine-linear-modules-of-different-lengths.fda08b13.png";